<script>
export default {
  name: 'DonationPublicDetails',
  props: {
    donation: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div>
    <h4 class="mt-10 mb-6">
      Gift Summary
    </h4>
    <div class="flex flex-col gap-3 text-sm md:text-base">
      <div class="flex gap-4 justify-between">
        <span class="text-gray-600">Donation Total:</span>
        <span>${{ donation.amount_gross_formatted }}</span>
      </div>
      <div class="flex gap-4 justify-between">
        <span class="text-gray-600">Date:</span>
        <span class="text-right"> {{ $filters.formatDateOnly(donation.created_at) }} </span>
      </div>
      <div class="flex gap-1 justify-between">
        <span class="text-gray-600">Campaign:</span>
        <span class="text-right"> {{ donation.cached.fundraiser_title }}</span>
      </div>
      <div v-if="donation.cached.beneficiary_user_name" class="flex gap-1 justify-between">
        <span class="text-gray-600">Allocation:</span>
        <span class="text-right"> {{ donation.cached.beneficiary_user_name }}</span>
      </div>
      <div v-if="donation.billing_method" class="flex gap-1 justify-between">
        <span class="text-gray-600">Giving Method:</span>
        <span class="text-right">{{ donation.billing_method }}</span>
      </div>
      <div v-if="donation.billing_transaction_id" class="flex gap-1 justify-between">
        <span class="text-gray-600">Transaction No.:</span>
        <span class="text-right"> {{ donation.billing_transaction_id }}</span>
      </div>
    </div>
    <h4 class="mt-10 mb-6">
      Donor Summary
    </h4>

    <div class="font-sans flex flex-col gap-2 text-sm md:text-base">
      <div> {{ donation.billing_name }} </div>
      <div> {{ donation.billing_address }} </div>
      <div> {{ donation.billing_city }}, {{ donation.billing_state }} {{ donation.billing_zip }} </div>
      <div> {{ donation.billing_phone }} </div>
      <div> {{ donation.billing_email }} </div>
    </div>
  </div>
</template>

<style scoped>

</style>
